import React, { useState } from 'react';
import { XMarkIcon, CreditCardIcon, ArrowTopRightOnSquareIcon, ShieldCheckIcon } from '@heroicons/react/24/outline';
import axios from 'axios';
import toast from 'react-hot-toast';
import { formatFcfa } from '../../utils/formatFcfa';

const PaymentModal = ({ plan, isOpen, onClose }) => {
  const [loading, setLoading] = useState(false);

  const handlePay = async () => {
    if (!plan || loading) return; // double clic : un seul paiement initialisé
    setLoading(true);
    try {
      const res = await axios.post('/api/payments/initialize', { planId: plan.id });
      if (res.data.checkoutUrl) {
        window.location.href = res.data.checkoutUrl;
      } else {
        toast.error("Erreur lors de l'initialisation du paiement");
        setLoading(false);
      }
    } catch (error) {
      toast.error(error.response?.data?.message || 'Erreur lors du paiement');
      setLoading(false);
    }
  };

  if (!isOpen || !plan) return null;


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-text flex items-center">
              <CreditCardIcon className="h-6 w-6 mr-2 text-primary-600" />
              Paiement — {plan.name}
            </h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
              disabled={loading}
            >
              <XMarkIcon className="h-5 w-5 text-gray-500" />
            </button>
          </div>

          <div className="mb-5 p-4 bg-gray-50 rounded-lg border border-gray-200">
            <div className="flex justify-between items-center mb-2">
              <span className="text-gray-600">Plan sélectionné</span>
              <span className="font-semibold text-text">{plan.name}</span>
            </div>
            <div className="flex justify-between items-center">
              <span className="text-gray-600">Montant</span>
              <div className="text-right">
                <span className="text-2xl font-bold text-primary-600">{formatFcfa(plan.priceXof)}</span>
                <span className="text-gray-500">/mois</span>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-800 flex items-start">
              <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-2 mt-0.5 flex-shrink-0" />
              Vous allez être redirigé vers la plateforme sécurisée FedaPay pour finaliser votre paiement en toute sécurité.
            </p>
          </div>

          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors"
              disabled={loading}
            >
              Annuler
            </button>
            <button
              onClick={handlePay}
              disabled={loading}
              className="px-6 py-2 bg-primary-500 text-white rounded-lg hover:bg-primary-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Redirection...
                </>
              ) : (
                <>
                  <ArrowTopRightOnSquareIcon className="h-4 w-4 mr-2" />
                  Payer avec FedaPay
                </>
              )}
            </button>
          </div>

          <div className="mt-4 flex items-center justify-center text-xs text-gray-500 space-x-1">
            <ShieldCheckIcon className="h-4 w-4 text-green-500" />
            <span>Paiement sécurisé par FedaPay — vos données ne transitent pas par nos serveurs</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
